export default __webpack_public_path__ + "static/media/Group-9645.1ff36f66.png";